"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;
exports.getWidth = getWidth;
var _lodashEs = require("lodash-es");
var _react = require("react");
var _styledComponents = require("styled-components");
var _analytics = require("../../../packages/analytics");
var _jsxRuntime = require("react/jsx-runtime");
const StyledContainer = _styledComponents.styled.div`${function (_ref) {
  let {
    $css
  } = _ref;
  return (0, _styledComponents.css)`
	box-sizing: border-box;
    ${$css}`;
}}
  `;
const breakpoints = {
  mobile: 0,
  tablet: 640,
  desktop: 1000
  // xl: 1800,
};
const VARIANT_ALIASES = {
  mobile: function (value) {
    return `@media (width >= ${breakpoints.mobile}px) and (width < ${breakpoints.tablet}px) { ${value} }`;
  },
  tablet: function (value) {
    return `@media (width >= ${breakpoints.tablet}px) and (width < ${breakpoints.desktop}px) { ${value} }`;
  },
  desktop: function (value) {
    return `@media (width >= ${breakpoints.desktop}px) { ${value} }`;
  },
  "max-mobile": function (value) {
    return `@media (width < ${breakpoints.tablet}px) { ${value} }`;
  },
  "max-tablet": function (value) {
    return `@media (width < ${breakpoints.desktop}px) { ${value} }`;
  },
  "min-mobile": function (value) {
    return `@media (width >= ${breakpoints.mobile}px) { ${value} }`;
  },
  "min-tablet": function (value) {
    return `@media (width >= ${breakpoints.tablet}px) { ${value} }`;
  },
  "min-desktop": function (value) {
    return `@media (width >= ${breakpoints.desktop}px) { ${value} }`;
  }
};
const getFlexProperty = function (value) {
  switch (value) {
    case "row":
      return "flex-direction: row";
    case "row-reverse":
      return "flex-direction: row-reverse";
    case "column":
      return "flex-direction: column";
    case "column-reverse":
      return "flex-direction: column-reverse";
    case "nowrap":
      return "flex-wrap: nowrap";
    case "wrap":
      return "flex-wrap: wrap";
    case "wrap-reverse":
      return "flex-wrap: wrap-reverse";
    default:
      return "display: flex";
  }
};
const TARGET_FLEXBOX = " > .component-container-wrapper > .aem-container";
const TARGET_FLEX_ITEM = `${TARGET_FLEXBOX} > .aem-GridColumn`;
const getOrderValue = function (value) {
  if (!value) return;
  return value.split(",").map(function (v) {
    return parseInt(v, 10);
  }).filter(function (n) {
    return !Number.isNaN(n);
  }).map(function (order, index) {
    return `${TARGET_FLEX_ITEM}:nth-child(${index + 1}) { order: ${order}; }`;
  }).join("");
};
const CSS_PROP_ALIASES = {
  m: function (value) {
    return `margin: ${getSpacing(value)};`;
  },
  ml: function (value) {
    return `margin-left: ${getSpacing(value)};`;
  },
  mr: function (value) {
    return `margin-right: ${getSpacing(value)};`;
  },
  mt: function (value) {
    return `margin-top: ${getSpacing(value)};`;
  },
  mb: function (value) {
    return `margin-bottom: ${getSpacing(value)};`;
  },
  mx: function (value) {
    return `
    ${CSS_PROP_ALIASES.ml(value)}
    ${CSS_PROP_ALIASES.mr(value)}
  `;
  },
  my: function (value) {
    return `
    ${CSS_PROP_ALIASES.mt(value)}
    ${CSS_PROP_ALIASES.mb(value)}
  `;
  },
  p: function (value) {
    return `padding: ${getSpacing(value)};`;
  },
  pl: function (value) {
    return `padding-left: ${getSpacing(value)};`;
  },
  pr: function (value) {
    return `padding-right: ${getSpacing(value)};`;
  },
  pt: function (value) {
    return `padding-top: ${getSpacing(value)};`;
  },
  pb: function (value) {
    return `padding-bottom: ${getSpacing(value)};`;
  },
  px: function (value) {
    return `
		${CSS_PROP_ALIASES.pl(value)}
		${CSS_PROP_ALIASES.pr(value)}
	`;
  },
  py: function (value) {
    return `
		${CSS_PROP_ALIASES.pt(value)}
		${CSS_PROP_ALIASES.pb(value)}
	`;
  },
  text: function (value) {
    return `text-align: ${value};`;
  },
  w: function (value) {
    return `width: ${getWidth(value)};`;
  },
  "max-width": function (value) {
    return `max-width: ${getWidth(value)};`;
  },
  "site-width": function () {
    return `
		max-width: ${getWidth("site")};
		width: 100%;
		margin-left: auto;
		margin-right: auto;
	`;
  },
  columns: function (value) {
    return `columns: ${value};`;
  },
  gap: function (value) {
    return `${TARGET_FLEXBOX} { gap: ${value}; }`;
  },
  "gap-x": function (value) {
    return `${TARGET_FLEXBOX} {
column-gap: ${value}; }`;
  },
  "gap-y": function (value) {
    return `${TARGET_FLEXBOX} {
row-gap: ${value}; }`;
  },
  color: function (value) {
    return `color: ${value};`;
  },
  bg: function (value) {
    return `background-color: ${value};`;
  },
  hide: function () {
    return `
    display: none;
    content-visibility: none;
  `;
  },
  flex: function (value) {
    return `${TARGET_FLEXBOX} { ${getFlexProperty(value)}; }`;
  },
  order: getOrderValue
};
function getSpacing(value) {
  if (!Number.isNaN(Number(value)) && value !== "") {
    return `calc(--app-spacing-size * ${value})`;
  }
  return value;
}
function getWidth(value) {
  if (value === "site") {
    return "1440px";
  }
  return value;
}
function splitAtFirstNumberOrBracket(input) {
  if (typeof input === "undefined") return input;
  const match = input.match(/-(?=[\d[\]]+)/);
  if (!match || typeof match.index === "undefined") return [input, ""];
  const index = match.index;
  const firstPart = input.slice(0, index);
  const secondPart = input.slice(index + 1);
  return [firstPart, secondPart];
}
function parseValue(str) {
  // Check if the string starts with '[' and ends with ']'
  let content = str;
  if (str.startsWith("[") && str.endsWith("]")) {
    content = str.slice(1, -1).trim(); // Remove brackets and trim whitespace
  }
  return content;
}
const getClassnameSyntax = function (str) {
  var _splitAtFirstNumberOr, _CSS_PROP_ALIASES$pro;
  const variantArray = str.split(":");
  const containsVariant = variantArray.length > 1;
  const variants = containsVariant ? variantArray.slice(0, -1) : undefined;
  const variantFns = containsVariant ? variants === null || variants === void 0 ? void 0 : variants.map(function (i) {
    var _VARIANT_ALIASES$i;
    return (_VARIANT_ALIASES$i = VARIANT_ALIASES[i]) !== null && _VARIANT_ALIASES$i !== void 0 ? _VARIANT_ALIASES$i : function (v) {
      return v;
    };
  }) : [function (v) {
    return v;
  }];
  const query = containsVariant ? variantArray.at(-1) : variantArray[0];
  const alias = (_splitAtFirstNumberOr = splitAtFirstNumberOrBracket(query)) !== null && _splitAtFirstNumberOr !== void 0 ? _splitAtFirstNumberOr : [];
  const propertyAlias = alias[0];
  const cssFn = (_CSS_PROP_ALIASES$pro = CSS_PROP_ALIASES[propertyAlias]) !== null && _CSS_PROP_ALIASES$pro !== void 0 ? _CSS_PROP_ALIASES$pro : function () {
    return "";
  };
  const rawValue = alias[1];
  const value = parseValue(rawValue);
  return {
    classname: str,
    variants,
    variantFns,
    query,
    propertyAlias,
    rawValue,
    cssFn,
    value
  };
};
function getSyntaxObjects(str) {
  const classes = str.trim().split(/\s+/);
  return classes.map(getClassnameSyntax);
}
function parseClassname(str) {
  if (typeof str !== "string") return str;
  const classString = getSyntaxObjects(str).map(function (_ref2) {
    let {
      variantFns,
      cssFn,
      value
    } = _ref2;
    const variant = (0, _lodashEs.flowRight)(variantFns);
    return variant(cssFn(value));
  }).join(" ");
  return classString;
}
const useVisibility = function () {
  const ref = (0, _react.useRef)();
  const [isVisible, setIsVisible] = (0, _react.useState)(true);
  const updateVisibility = (0, _lodashEs.throttle)(setIsVisible, 100);
  (0, _react.useEffect)(function () {
    if (typeof ref.current === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(function () {
      var _ref$current;
      if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.checkVisibility()) {
        updateVisibility(true);
      } else {
        updateVisibility(false);
      }
    });
    observer.observe(ref.current);
    return function () {
      return observer.disconnect();
    };
  }, [updateVisibility]);
  return {
    ref,
    isVisible
  };
};
const Container = function (props) {
  const {
    className,
    children,
    ...rest
  } = props;
  const parsed = (0, _react.useMemo)(function () {
    return parseClassname(className);
  }, [className]);
  const {
    isVisible,
    ref
  } = useVisibility();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContainer, {
    $css: parsed,
    ref: ref,
    className: className,
    ...rest,
    "data-testid": "Container",
    children: isVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: children
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: "\xA0"
    })
  });
};
exports.Container = Container;
var _default = exports.default = (0, _analytics.withAnalytics)(Container)({
  _component: "ComponentContainer"
});